<template>
    <form
        ref="MEGAZONE_AUTH_POPS"
        action="https://login.megazone.com/oauth/authorize"
    >
        <input type="hidden" name="response_type" value="code">
        <input type="hidden" name="client_id" :value="POPS_CLIENT_ID">
        <input type="hidden" name="redirect_uri" :value="POPS_CLIENT_REDIRECT_URI + '/oauth/authorize'">
    </form>
</template>

<script>
export default {
    data () {
        return {
            POPS_CLIENT_ID: process.env.VUE_APP_POPS_CLIENT_ID,
            POPS_CLIENT_REDIRECT_URI: process.env.VUE_APP_POPS_CLIENT_REDIRECT_URI
        }
    },
    mounted () {
        this.$refs.MEGAZONE_AUTH_POPS.submit()
    }
}
</script>

<style>

</style>
